(function($){
    $(document).ready(function() {
        $('[type="datepicker"], [data-name="data_urodzenia"] input, [data-name="data_zakonczenia"] input, [data-name="data_rozpoczecia"] input').inputmask({
            mask: "99-99-9999",
            placeholder: "DD-MM-RRRR"
        });
        $('[data-name="kod_pocztowy"] input').inputmask('99-999');
        $('[data-name="telefon_stacjonarny"] input, [name="client_landline"]').inputmask('99/999-99-99');
        $('[data-name="telefon_komorkowy"] input, [name="client_mobile"]').inputmask('999-999-999');
    });
})(jQuery)